__turbopack_context__.v({
  "applyButton": "CJobOffers-module__WhAtwq__applyButton",
  "applyWrap": "CJobOffers-module__WhAtwq__applyWrap",
  "article": "CJobOffers-module__WhAtwq__article",
  "articleBack": "CJobOffers-module__WhAtwq__articleBack",
  "articleBackLink": "CJobOffers-module__WhAtwq__articleBackLink",
  "articleHeader": "CJobOffers-module__WhAtwq__articleHeader",
  "articleMainImage": "CJobOffers-module__WhAtwq__articleMainImage",
  "articleMeta": "CJobOffers-module__WhAtwq__articleMeta",
  "articleTitle": "CJobOffers-module__WhAtwq__articleTitle",
  "body": "CJobOffers-module__WhAtwq__body",
  "card": "CJobOffers-module__WhAtwq__card",
  "cardLink": "CJobOffers-module__WhAtwq__cardLink",
  "cardMeta": "CJobOffers-module__WhAtwq__cardMeta",
  "cardMetaItem": "CJobOffers-module__WhAtwq__cardMetaItem",
  "cardMore": "CJobOffers-module__WhAtwq__cardMore",
  "cardRef": "CJobOffers-module__WhAtwq__cardRef",
  "cardTitle": "CJobOffers-module__WhAtwq__cardTitle",
  "empty": "CJobOffers-module__WhAtwq__empty",
  "fileLink": "CJobOffers-module__WhAtwq__fileLink",
  "fileSize": "CJobOffers-module__WhAtwq__fileSize",
  "files": "CJobOffers-module__WhAtwq__files",
  "filesHeading": "CJobOffers-module__WhAtwq__filesHeading",
  "filesList": "CJobOffers-module__WhAtwq__filesList",
  "filterActions": "CJobOffers-module__WhAtwq__filterActions",
  "filterForm": "CJobOffers-module__WhAtwq__filterForm",
  "gallery": "CJobOffers-module__WhAtwq__gallery",
  "galleryItem": "CJobOffers-module__WhAtwq__galleryItem",
  "list": "CJobOffers-module__WhAtwq__list",
  "root": "CJobOffers-module__WhAtwq__root",
  "section": "CJobOffers-module__WhAtwq__section",
  "sectionBody": "CJobOffers-module__WhAtwq__sectionBody",
  "sectionHeading": "CJobOffers-module__WhAtwq__sectionHeading",
  "thumb": "CJobOffers-module__WhAtwq__thumb",
  "thumbWrap": "CJobOffers-module__WhAtwq__thumbWrap",
});
